

export const ActionTypes = {
  PUSH_CHANGE: 'zola/cards/form_history/PUSH_CHANGE',
  POP_CHANGE: 'zola/cards/form_history/POP_CHANGE',
  CLEAR_HISTORY: 'zola/cards/form_history/CLEAR_HISTORY',
};


export const pushChange = changeFunc => ({
  type: ActionTypes.PUSH_CHANGE,
  payload: changeFunc
});

const popChange = () => ({
  type: ActionTypes.POP_CHANGE,
});

// return a promise to avoid race condition when
// skipping undos on a deleted element
export const popChangeAsync = () => dispatch => (
  new Promise((resolve) => {
    dispatch(popChange());
    resolve();
  })
);

export const clearHistory = () => ({
  type: ActionTypes.CLEAR_HISTORY
});



/** WEBPACK FOOTER **
 ** ./src/cards/actions/formHistoryActions.js
 **/